
import React from 'react';

export const TechniqueLoadingState: React.FC = () => {
  return (
    <div className="space-y-6 animate-pulse">
      <div className="h-8 bg-muted/40 rounded w-2/3" />
      <div className="h-64 bg-muted/40 rounded" />
      <div className="space-y-2">
        <div className="h-4 bg-muted/40 rounded w-full" />
        <div className="h-4 bg-muted/40 rounded w-5/6" />
        <div className="h-4 bg-muted/40 rounded w-4/6" />
      </div>
    </div>
  );
};
